// fake nonce for EOA simulation
export const EOA_SIMULATION_NONCE =
  '0x1000000000000000000000000000000000000000000000000000000000000000'
